import { Injectable } from '@angular/core';

@Injectable()
export class CommonUtils {
  isArrayInArray(parentArray: Array<any>, childArray: Array<any>): boolean {
    if (0 === parentArray.length || childArray == null) {
      return false;
    }

    return (
      parentArray.filter(function (item) {
        return childArray.indexOf(item) > -1;
      }).length === childArray.length
    );
  }
}
